import { render } from "./PlayerList.vue?vue&type=template&id=49190186&scoped=true&bindings={}"
import script from "./PlayerList.vue?vue&type=script&lang=ts"
export * from "./PlayerList.vue?vue&type=script&lang=ts"

import "./PlayerList.vue?vue&type=style&index=0&id=49190186&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-49190186"

export default script